import { Post } from 'src/axios';
import { TAskForm } from 'src/types/shared';

export const sendAskForm = (params: TAskForm) =>
  Post<string>('/feedback/question/', params);
